module.exports = __webpack_public_path__ + "img/email_notifications_border.b650b735.svg";